<div class="patient-email-card d-flex align-items-center">
  <mat-icon class="me-2 md-18">email</mat-icon>
  <span class="text">
        <span>{{emailAddress}}</span>
    </span>
</div>
